<div class="grid grid-cols-12 gap-4">
  @for (item of options; track $index) {
  <div class="lg:col-span-4 md:col-span-6 sm:col-span-12 col-span-12">
    <c-multi-checkbox-item
      [itemProperty]="itemProperty"
      [data]="item"
      (selectedData)="processData($event)"
      [check]="initProcess(item)"
    />
  </div>
  }
</div>
